// IE cannot read inline css variables, colors are defined in style/index.scss
export const COLOR = {
  LIGHT_PURPLE: '#b4b5df',
  YELLOW: '#c9a84c',
  PINK: '#ecbaa8',
  LIGHT_BLUE: '#e8eff6',
  DARK_GREEN: '#0b3d6b',
};

export const GUEST = 'GUEST';

export const ACTIVITY_TYPE = {
  LOGIN_LAUNCHPAD: 'Login Launchpad',
  LOGOUT_LAUNCHPAD: 'Logout Launchpad',
  ACCESS_REPORT: 'Access Report',
  ACCESS_APPLICATION: 'Access Application',
  ACCESS_NEW_CLAIM_FORM: 'Access New Claim Form',
  EDIT_EXISTING_CLAIM_FORM: 'Edit Existing Claim Form',
  VIEW_SUBMITTED_CLAIM_FORM: 'View Submitted Claim Form',
  SUBMIT_CLAIM_FORM: 'Submit Claim Form',
};

export const FILE_FORMAT = {
  PDF: 'PDF',
  PPTX: 'PPTX',
  PNG: 'PNG',
};

export const REPORT_TYPE = {
  PAGINATED: 'PaginatedReport',
  DASHBOARD: 'PowerBIReport',
};
